module.exports = __webpack_public_path__ + "ed8fe1b4cbdb7dc5b4265126db0662c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/netflix_2022_chart.png
// module id = 1702
// module chunks = 0